document.addEventListener("DOMContentLoaded", function () {
  loadProducts();
});
function loadProducts() {
  let loadingBtn = document.querySelector("#loading_next .button");

  if (loadingBtn) {
    loadingBtn.addEventListener("click", function () {
      let productsPerPage = parseInt(
        document.querySelector("[data-products-per-page]").value
      )
      let totalPages = parseInt(
          document.querySelector("[data-total-pages]").value
        ),
        currentPage = (fixedPage = parseInt(
          document.querySelector("[data-current-page]").value
        )),
        nextUrlSelector = document.querySelector("[data-next-url]"),
        productCountWrapper = document.querySelector(
          "[data-products-count-text]"
        );

      if (currentPage < totalPages) {
        if (loadingBtn) loadingBtn.classList.add("loading-products");
        if (loadingBtn && loadingBtn.querySelector(".loading-overlay__spinner"))
          loadingBtn
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        currentPage += 1;
        let nextUrl = (nextUrlSelector.value = nextUrlSelector.value.replace(
          /page=[0-9]+/,
          "page=" + currentPage
        ));
        document.querySelector("[data-current-page]").value = currentPage;

        if (window.nostoLoading) {
          const collectionPaginatedSize = productsPerPage || 40;
          handleNostoApiCall(fixedPage * collectionPaginatedSize, true, window.location.search, collectionPaginatedSize);
        } else {
          fetch(nextUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              if (document.querySelector("#product-grid"))
                document.querySelector("#product-grid").innerHTML +=
                  new DOMParser()
                    .parseFromString(html, "text/html")
                    .getElementById("product-grid").innerHTML;
              if (productCountWrapper) {
                let nOfProducts =
                    document.querySelectorAll("#product-grid li").length,
                  productCountsText = {
                    "{{total_products}}":
                      productCountWrapper.dataset.totalProducts,
                    "{{current_products}}": nOfProducts,
                  };
                productCountWrapper.querySelector("span").innerHTML =
                  productCountWrapper.dataset.productsCountText.replace(
                    /{{total_products}}|{{current_products}}/gi,
                    function (matched) {
                      return productCountsText[matched];
                    }
                  );
              }
              if (loadingBtn) loadingBtn.classList.remove("loading-products");
              if (
                loadingBtn &&
                loadingBtn.querySelector(".loading-overlay__spinner")
              )
                loadingBtn
                  .querySelector(".loading-overlay__spinner")
                  .classList.add("hidden");
              if (currentPage == totalPages) {
                loadingBtn.style.display = "none";
              }
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              document.dispatchEvent(
                new CustomEvent("swym:collections-loaded")
              );
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
    });
  }
}
